var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTip)?_c('div',{staticClass:"tip",on:{"click":function($event){_vm.showTip = false}}},[_c('img',{attrs:{"src":require("@/assets/image/share_tip.png"),"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }